import { PageHeader, SectionCard } from "@/components/Primitives";
import { Calendar, Users, FileText, Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const MOCK = [
  { id: "m1", title: "Q3 OKR Planning", date: "Feb 12 · 10:00", participants: 8, project: "Atlas Platform", summary: "Discussed Q3 roadmap. Backend team to finalize scope by Feb 20." },
  { id: "m2", title: "Sprint 24 Review", date: "Feb 11 · 15:30", participants: 12, project: "Nova Analytics", summary: "Delivered 32 story points. 3 items rolled over. Focus on API latency next sprint." },
  { id: "m3", title: "Design System Sync", date: "Feb 10 · 09:00", participants: 5, project: "Zenith Dashboard", summary: "Adopted new token architecture. Rolling out across 3 apps by end of month." },
];

export default function Meetings() {
  return (
    <div className="space-y-6">
      <PageHeader testid="meetings-header" title="Meetings" subtitle="Recordings, transcripts & AI action items" />

      <div className="grid md:grid-cols-2 gap-4">
        {MOCK.map((m) => (
          <div key={m.id} className="data-card p-5 card-lift">
            <div className="flex items-start justify-between mb-2">
              <div className="font-display font-semibold text-lg tracking-tight">{m.title}</div>
              <Badge variant="outline">{m.project}</Badge>
            </div>
            <div className="text-xs text-muted-foreground flex items-center gap-3 mb-3">
              <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{m.date}</span>
              <span className="flex items-center gap-1"><Users className="w-3 h-3" />{m.participants}</span>
            </div>
            <div className="p-3 rounded-lg bg-primary/5 border border-primary/20 text-sm">
              <div className="flex items-center gap-2 mb-1"><Sparkles className="w-3.5 h-3.5 text-primary" /><span className="text-xs font-medium">AI Summary</span></div>
              <div className="text-xs text-muted-foreground">{m.summary}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
